import { SimplePage } from "@/app/_/marketing/SimplePage";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Careers"
      title="Come build with us."
      subtitle="We're hiring across engineering, design, and GTM. If you're excited about AI, accounting, or both, we'd love to hear from you."
      primaryCta={{
        label: "Email us",
        to: "/company/contact",
      }}
    />
  );
}
